const DOMAIN = 'https://marketing.xinli001.cc/',
    APIS = {
        jsconfig: `${DOMAIN}h5/common/wxjsconfigmp`,
        shouquan: `${DOMAIN}h5/common/wxauth`,
        ceshi: `${DOMAIN}cp/common/ceshi`,
        result: `${DOMAIN}cp/common/result`,
        checklogin: `${DOMAIN}h5/common/checklogin`,
        H5URL: 'https://mkstatic.yixinli001.com/h5app/halloween/index.html',
        event: `${DOMAIN}data/index/event`,
    }

export default APIS